import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaGlobe } from 'react-icons/fa';
import './LanguageSwitcher.css';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng).then(() => {
      // Set RTL direction for Arabic, LTR for all other languages
      document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
      document.documentElement.lang = lng;
    }).catch((error) => {
      console.error('🌍 Error changing language:', error);
    });
  };


  return (
    <div className="language-switcher">
      <FaGlobe className="globe-icon" />
      <select
        value={i18n.language}
        onChange={(e) => changeLanguage(e.target.value)}
        className="language-select"
      >
        <option value="en">🇺🇸 English</option>
        <option value="fr">🇫🇷 Français</option>
        <option value="ar">🇹🇳 العربية</option>
      </select>
    </div>
  );
};

export default LanguageSwitcher; 